import { type ErrorEvent } from '@sentry/react';

import { isDefined } from 'app-shared/utils';

// A page address can carry one-time sign-in parameters: Sentry gets the page,
// never its query string.
export const removeQueryStringFromSentryEvent = (
  event: ErrorEvent,
): ErrorEvent =>
  isDefined(event.request?.url)
    ? {
        ...event,
        request: { ...event.request, url: event.request.url.split('?')[0] },
      }
    : event;
